import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { media, palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    main: {},
    section: {
      maxWidth: 980,
      margin: '0 auto',
      flexGrow: 1,
      padding: '30px 20px',

      [media.tablet]: {
        padding: '30px 24px',
      },

      [media.desktop]: {
        padding: '30px 40px',
      },
    },
    content: {
      color: 'white',
      margin: '0 auto',

      display: 'flex',
      flexDirection: 'column',

      [media.desktop]: {
        maxWidth: 980,
      },
    },
    title: {
      fontSize: 24,
      fontWeight: 'bold',
      color: palette.red,
      textAlign: 'center',
      marginTop: 47,
      marginBottom: 28,
      [media.tablet]: {
        fontSize: 35,
        marginTop: 50,
        marginBottom: 40,
      },
      [media.desktop]: {
        fontSize: 40,
        marginTop: 70,
        marginBottom: 60,
      },
    },
    description: {
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: 53,
      [media.tablet]: {
        marginBottom: 64,
      },
      [media.desktop]: {
        fontSize: '20px',
        lineHeight: '24px',
        marginBottom: 100,
      },
    },
    achievements: {
      width: '100%',
      maxWidth: 860,
      alignSelf: 'flex-end',

      [media.desktop]: {
        paddingRight: 0,
      },
      [media.tablet]: {
        paddingRight: 46,
      },
      ':nth-child(1n) > div': {
        marginBottom: 37,
        [media.desktop]: {
          marginBottom: 100,
        },
        [media.tablet]: {
          marginBottom: 95,
        },
      },
    },
  });
};
